import React from "react";
import { FilterFuncts } from "@wit/mpesa-ui-components/lib/hooks/use-filters.hook";
import { SearchBar } from "@wit/mpesa-ui-components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SearchBarFilterContainer } from "../../../../shared/responsive-ui.styled";
import { RatioContainer, Row } from "../../../../shared/shared.styled";

export enum JobsFilterKeys {
  JOB = "job",
}

interface ITriggerJobFiltersProps extends FilterFuncts {
  refreshResults: () => void;
}

/**
 * Till number filter components
 * @param param0
 * @returns
 */
const TriggerJobFilters = ({
  filters,
  clearFilter,
  isFilterActive,
  resetFilters,
  updateFilter,
  updateMultipleFilters,
  refreshResults,
}: ITriggerJobFiltersProps) => {
  const [t] = useTranslation();

  return (
    <>
      <CustomRow>
        <SearchBarFilterContainer>
          <SearchBar
            value={filters.has(JobsFilterKeys.JOB) ? (filters.get(JobsFilterKeys.JOB) as string[])[0] : ""}
            onChange={e => {
              if (e.target.value) {
                updateFilter(JobsFilterKeys.JOB, e.target.value, true);
              } else {
                clearFilter(JobsFilterKeys.JOB);
              }
            }}
            clearValue={() => clearFilter(JobsFilterKeys.JOB)}
            placeholderLabel={t("pages.tools.jobsList.triggerJob.searchPlaceholder")}
          />
        </SearchBarFilterContainer>
      </CustomRow>
    </>
  );
};

export default TriggerJobFilters;

const CustomRow = styled(Row)`
  margin-bottom: 18px;
  margin-top: 18px;

  > ${RatioContainer} {
    margin-right: 24px;

      margin-right: 0;
    }
  }
`;
